export default "__VITE_ASSET__Btc6EC3u__"